import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  location: 'Buenos Aires',
  role: 'Terapeuta Holística',
  quote: 'Finalmente encontré una formación que respeta mi tiempo y mi inteligencia. El Nivel I me dio la base que necesitaba para empezar a practicar con confianza. La claridad de los manuales es impresionante.',
  initials: 'MG'
}, {
  name: 'Carolina R.',
  location: 'Ciudad de México',
  role: 'Psicóloga',
  quote: 'El Combo 2 fue la mejor inversión que hice en mi desarrollo profesional. Los manuales son completos, claros y muy bien estructurados. Pude integrar el Reiki en mis sesiones de terapia con resultados increíbles.',
  initials: 'CR'
}, {
  name: 'Valentina M.',
  location: 'Bogotá',
  role: 'Estudiante de Yoga',
  quote: 'Lo que más valoro es la progresión lógica entre niveles. Se nota que fue diseñado por alguien que realmente entiende la enseñanza del Reiki. Los bonus de chakras son una joya por sí mismos.',
  initials: 'VM'
}, {
  name: 'Roberto S.',
  location: 'Santiago de Chile',
  role: 'Masajista Terapéutico',
  quote: 'Llevaba años buscando una formación seria que no fuera "mística" en exceso. Este sistema es profesional, directo y aplicable. Mis clientes notaron la diferencia en la energía desde la primera semana.',
  initials: 'RS'
}, {
  name: 'Ana Paula L.',
  location: 'Lima',
  role: 'Enfermera',
  quote: 'Como profesional de la salud, era escéptica. Pero la estructura y el enfoque profesional de este material me convencieron. Es una herramienta complementaria fantástica para el cuidado del paciente.',
  initials: 'AL'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-[#1e1254]" data-id="element-293">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <div className="text-center mb-16" data-id="element-295">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-296">
            Lo que Dicen Nuestros Estudiantes
          </h2>
          <div className="h-1 w-20 bg-[#d4af37] mx-auto rounded-full" data-id="element-297" />
          <p className="text-purple-200 mt-4 max-w-2xl mx-auto" data-id="element-298">
            Únete a cientos de profesionales que ya han transformado su práctica
            con nuestro sistema.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-center" data-id="element-299">
          {testimonials.map((t, i) => <motion.div key={i} className="bg-[#0f0a2e] p-8 rounded-lg border border-purple-900/50 relative flex flex-col h-full" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} data-id="element-300">
              <div className="flex gap-1 mb-4" data-id="element-301">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-[#d4af37] fill-current" data-id="element-302" />)}
              </div>
              <p className="text-purple-100 italic mb-6 leading-relaxed flex-grow" data-id="element-303">
                "{t.quote}"
              </p>
              <div className="flex items-center mt-auto border-t border-purple-900/30 pt-4" data-id="element-304">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center text-white font-bold text-sm mr-3 shadow-lg" data-id="element-305">
                  {t.initials}
                </div>
                <div data-id="element-306">
                  <p className="text-white font-semibold text-sm" data-id="element-307">{t.name}</p>
                  <p className="text-purple-400 text-xs" data-id="element-308">
                    {t.location} • {t.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}